/**
 * Category API Service
 * REST: GET/POST /api/categories, DELETE /api/categories/{id}
 *
 * Ersetzt die bisherige rein lokale (localStorage-basierte) Kategorien-
 * Verwaltung in CategoryContext.js. Siehe TODO_Archiv_Backend.md Abschnitt 2.
 */

const getBaseUrl = () => process.env.REACT_APP_API_URL || '/api';

const getAuthToken = () => localStorage.getItem('authToken');

const getHeaders = () => {
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

async function apiFetch(endpoint, options = {}) {
  const url = `${getBaseUrl()}${endpoint}`;

  const response = await fetch(url, {
    ...options,
    headers: getHeaders(),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Nicht autorisiert. Bitte erneut anmelden.');
    }
    if (response.status === 403) {
      throw new Error('Zugriff verweigert.');
    }
    if (response.status === 404) {
      throw new Error('Kategorie nicht gefunden.');
    }
    if (response.status === 409) {
      throw new Error('Kategorie existiert bereits.');
    }
    const errorText = await response.text();
    throw new Error(errorText || `HTTP Error: ${response.status}`);
  }

  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  }
  return { success: true };
}

const categoryApi = {
  /**
   * Liste aller Kategorien des Nutzers (nach Name sortiert)
   */
  async getAll() {
    return apiFetch('/categories');
  },

  /**
   * Neue Kategorie anlegen
   * @param {string} name
   * @returns {Promise<{id:number,name:string,createdAt:string,updatedAt:string}>}
   * @throws bei 409 Conflict (Name existiert bereits, case-insensitive)
   */
  async create(name) {
    return apiFetch('/categories', {
      method: 'POST',
      body: JSON.stringify({ name }),
    });
  },

  /**
   * Kategorie löschen (Hard-Delete, kein serverseitiges Soft-Delete/Archiv -
   * das Archivieren übernimmt weiterhin das Frontend explizit vor dem Delete)
   */
  async remove(id) {
    return apiFetch(`/categories/${id}`, {
      method: 'DELETE',
    });
  },
};

export default categoryApi;
